module.exports = "/images/biological-hazard@3x.png?4c88039b15cad0435b2f86fbe8acfd04";